import { render, staticRenderFns } from "./Penghasilan.vue?vue&type=template&id=2a0376d3&"
import script from "./Penghasilan.vue?vue&type=script&lang=js&"
export * from "./Penghasilan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports